$ = require 'jquery'
Alerts = require 'views/lib/alerts'
ApiAjax = require 'network/api-ajax'
Board = require 'models/board'
Organization = require 'models/organization'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'
localizeServerError = require 'lib/localize-server-error'

module.exports = class SelectMemberRoleView extends View
  viewTitleKey: 'add as'

  initialize: ->
    @parent = @options.parent
    @member = @model

    @isBoard = @isOrg = false
    @objText = ""
    @didSendInvite = true

    if @parent instanceof Board
      @isBoard = true
      @objText = "Board"
      @invitationList = @parent.invitationList
    else if @parent instanceof Organization
      @isOrg = true
      @objText = "Org"
    else
      throw new Error("A fragile abstraction has broken")

    @invitationList = @parent.invitationList

    # TODO: may need to delete a view if member joins/leaves an org,
    # also if they accepted an invite, etc.

  events:
    'click .js-invite': 'invite'

  render: ->
    data =
      showAdmin: @parent.owned(@member) && @options.canMakeAdmin
      showObserver: @parent.hasObservers()

    localizationKey = if @isBoard
      'board roles'
    else if @isOrg
     'org roles'
    else
      throw new Error("A fragile abstraction has broken")

    for role in @parent.getAvailableRoles()
      data["roleText_#{role}"] = l([localizationKey, role, 'text'])
    data["roleText_admin"] ?= data["roleText_superadmin"]

    @$el.html(
      templates.fill(
        'manage_members_select_role',
        data
      )
    )

    @

  invite: (e) ->
    Util.stop(e)

    $target = $(e.target).closest('.js-invite')

    type = if $target.hasClass('js-select-admin')
      'admin'
    else if $target.hasClass('js-select-member')
      'normal'
    else if $target.hasClass('js-select-observer')
      'observer'

    ApiAjax
      url: "/1/#{@parent.typeName.toLowerCase()}/#{@parent.id}/members/#{@member.id}"
      type: 'put'
      data: { type }
      dataType: 'json'
      success: (data) =>
        track("Invitations", "Add Member to Board", "Role: #{type}")
      error: (res, err) =>
        message = localizeServerError(res)
        Alerts.showLiteralText(message, 'error', 'alert', 3000)
        track("Invitations", "Error: #{res.responseText}")
        return

    @options.onSendInvite?()
    @options.onSendInvite = null

    PopOver.hide()

    return



// WEBPACK FOOTER //
// ./app/scripts/views/member/select-member-role-view.coffee